import { createContext, useContext, useState, useEffect } from "react";
import {
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  signOut,
  updateProfile,
} from "firebase/auth";
import { ref, get } from 'firebase/database';

import { auth, db } from "../config/firebase";

const AuthContext = createContext();

export function useAuth() {
  return useContext(AuthContext);
}

export function AuthProvider({ children }) {
  const [currentUser, setCurrentUser] = useState();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [userHandle, setUserHandle] = useState(null);

  function register(email, password) {
    return createUserWithEmailAndPassword(auth, email, password);
  }

  function login(email, password) {
    return signInWithEmailAndPassword(auth, email, password);
  }

  function logout() {
    setUserHandle(null); // Clear handle on logout
    return signOut(auth);
  }

  function setHandle(handle) {
    setUserHandle(handle);
  }

  function updateUserProfile(user, profile) {
    return updateProfile(user, profile);
  }

  // Fetch user handle from handleStore
  const fetchUserHandle = async (userId) => {
    try {
      const handleStoreRef = ref(db, 'handleStore');
      const snapshot = await get(handleStoreRef);

      if (snapshot.exists()) {
        const handleStore = snapshot.val();
        for (const [handle, mappedUserId] of Object.entries(handleStore)) {
          if (mappedUserId === userId) {
            setUserHandle(handle);
            return;
          }
        }
      }
    } catch (error) {
      console.error('Error fetching user handle:', error);
    }
  };

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
      setCurrentUser(user);
      if (user) {
        // Fetch handle for existing users (new signups will set handle directly)
        if (!userHandle) {
          fetchUserHandle(user.uid);
        }
      } else {
        setUserHandle(null); // Clear handle when user logs out
      }
      setLoading(false);
    });

    return unsubscribe;
  }, [userHandle]);

  const value = {
    currentUser,
    userHandle,
    error,
    setError,
    login,
    register,
    logout,
    setHandle,
    updateUserProfile,
  };

  return (
    <AuthContext.Provider value={value}>
      {!loading && children}
    </AuthContext.Provider>
  );
}